import React, { useMemo } from "react";
import { ToastOffset, Toaster } from "@fluentui/react-components";

import { M365PulseToasterProps } from "./M365PulseToaster.types";
import { observer } from "mobx-react";
import { useSmallScreen } from "Shared/Hooks";
import { useToasterStyles } from "./M365PulseToaster.styles";

const M365PulseToasterBase = (props: M365PulseToasterProps) => {
    const { toasterId, position } = props;
    const classNames = useToasterStyles();
    const isSmallScreen = useSmallScreen();
    const offset: ToastOffset = useMemo(() => {
        const horizontal = props.horizontal ?? (isSmallScreen ? 10 : 23);
        const vertical = props.vertical ?? 40;
        return { horizontal, vertical };
    }, [isSmallScreen, props.vertical, props.horizontal]);
    return <Toaster toasterId={toasterId} position={position} className={classNames.root} offset={offset} />;
};

export const M365PulseToaster = observer(M365PulseToasterBase);
